import moment from "moment-timezone";

export const isObjectTruthy = (obj) => {
  //
  if (
    obj &&
    typeof obj === "object" &&
    Object.keys(obj).length > 0 &&
    obj !== null
  )
    return true;
  return false;
};

export const isObjectWithArraysTruthy = (obj) => {
  // If every key with a value of an array has no length, then return false. If one array has a value, return true.
  let count = 0;
  Object.values(obj).forEach((array) => {
    if (!isArrayItems(array)) count++;
  });
  let flag = count === Object.values(obj).length ? false : true;
  return flag;
};

export const isArrayWithItems = (arr) => {
  if (!Array.isArray(arr) || arr.length < 1) return false;

  return arr.length > 0;
};

export const isArrayTruthy = (arr) => {
  if (!Array.isArray(arr)) return false;

  return arr.every((item) => !!item);
};

export const isArrayItems = (arr) => {
  if (!Array.isArray(arr)) return false;

  return arr.length > 0;
};

export const nFormatter = (num) => {
  let formatter = Intl.NumberFormat("en", { notation: "compact" });
  return formatter.format(num);
};

export const nFormatterFull = (num) => {
  try {
    let formatter = Intl.NumberFormat("en");
    return formatter.format(num);
  } catch (error) {
    return "!#N/A";
  }
};

export const dFormatter = (num) => {
  try {
    let formatter = Intl.NumberFormat("en", {
      style: "currency",
      currency: "USD",
    });

    return formatter.format(num);
  } catch (error) {
    return "!#N/A";
  }
};

export const dFormatterInteger = (num) => {
  try {
    let formatter = Intl.NumberFormat("en", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return formatter.format(num);
  } catch (error) {
    return "!#N/A";
  }
};

export const dFormatterDollars = (num) => {
  try {
    let formatter = Intl.NumberFormat("en", {
      style: "currency",
      currency: "USD",
    });
    return formatter.format(num).split(".")[0];
  } catch (error) {
    return "!#N/A";
  }
};

export const secondsToMins = (s) => {
  try {
    return new Date(s * 1000).toISOString().substring(14, 19);
  } catch (error) {
    return "!#N/A";
  }
};

export const secondsToHourMins = (s) => {
  try {
    const totalMinutes = Math.floor(s / 60);

    let seconds = (s % 60).toFixed();
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;

    hours =
      hours === 0 ? `` : hours > 99 ? `${nFormatterFull(hours)}h` : `${hours}h`;
    minutes =
      minutes === 0 ? `` : minutes < 10 ? `0${minutes}m` : `${minutes}m`;
    seconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${hours} ${minutes} ${seconds}s`;
  } catch (error) {
    return "!#N/A";
  }
};

export const truncateUserData = (user) => {
  try {
    let { signInUserSession, attributes, username } = user || {};

    return {
      signInUserSession,
      attributes,
      username,
    };
  } catch (error) {
    return undefined;
  }
};

export const parseJwt = (token)=> {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export const snakeToTitleCase = (s) => {
  try {
    return s
      .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
      .replace(/[-_]+(.)/g, (_, c) => " " + c.toUpperCase());
  } catch (error) {
    return s;
  }
};

export const interleave = (arr, thing) =>
  [].concat(...arr.map((n) => [n, thing])).slice(0, -1);

export const traverseObject = (obj, i) => {
  let o;
  isObjectTruthy(obj) && isObjectTruthy(obj[i]) ? (o = obj[i]) : (o = null);
  return o;
};

export const cleanStringFileName = (string) => {
  try {
    return string.replace(/[^a-z0-9]/gi, "_");
  } catch (error) {
    return "";
  }
};

export const cleanStringExcelSheet = (string) => {
  try {
    return string.replace(/[\[\]:\/\\\?\*]/gi, ""); //eslint-disable-line
  } catch (error) {
    return "";
  }
};

export const isDate = (string) => {
  return moment.isDate(string);
};

export const fuzzyMatch = (str, pattern) => {
  pattern = pattern.split("").reduce(function (a, b) {
    return a + ".*" + b;
  });

  return new RegExp(pattern, "i").test(str);
};

export const likeMatch = (str, pattern) => {
  try {
    return new RegExp(pattern, "i").test(str);
  } catch (error) {
    return false;
  }
};
export const clearMatch = (str, pattern) => {
  // Take a str and a pattern
  // Turn the pattern into an array of patterns
  // Match the str against the patterns
  // E.g. str: "age became a fan", pattern: ["fan, "age", "became"] should return true
  try {
    const searchQueryWordsArray = pattern
      // .split(/,| |-/)
      .split(/,| /) // Allow for dashes in search query
      .map(
        (word) => new RegExp(cleanSymbolsFromString(word.toLowerCase()), "gi")
      );

    const string = cleanSymbolsFromString(str).toLowerCase();

    const isMatch = searchQueryWordsArray.every((word) => word.test(string));

    return isMatch;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const cleanSymbolsFromString = (str) => {
  try {
    return str.replace(/[\W_]+/g, " ");
  } catch (error) {
    return str;
  }
};

export const sumArrayOfObjectsByValue = (arrayOfObjects, key) => {
  const total = Object.values(arrayOfObjects).reduce((total, object) => {
    if (typeof object[key] === "string") {
      return total + parseInt(object[key]);
    } else {
      return total + object[key];
    }
  }, 0);
  return total;
};

export const averageArrayOfObjectsByValue = (arrayOfObjects, key) => {
  const total = sumArrayOfObjectsByValue(arrayOfObjects, key);
  return total / arrayOfObjects.length;
};

export const weightedAverageArrayOfObjectsByValue = (
  arrayOfObjects,
  keyValue,
  keyWeight,
  weightSum
) => {
  // if the sum ofthe keyValue is 0, then return nothing (otherwise it would show infinity)
  try {
    if (sumArrayOfObjectsByValue(arrayOfObjects, keyValue) === 0) return 0;
    const weightedTotal = Object.values(arrayOfObjects).reduce(
      (total, object) => {
        return total + object[keyValue] * (object[keyWeight] / weightSum);
      },
      0
    );
    return weightedTotal;
  } catch (error) {
    return "!#N/A";
  }
};

export const dateToLocaleMDDYYYY = (string) => {
  try {
    const d = new Date(string);
    if (isDate(d)) {
      return moment(string).format("LL");
    } else {
      return string;
    }
  } catch (error) {
    return "!#N/A";
  }
};

export const formatDate = (string) => {
  try {
    let d = moment(string)
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("MMM DD YYYY, h:mm A zz");

    if (d === "Invalid date") throw new Error("Not a date...");
    return d;
  } catch (error) {
    return "";
  }
};

export const parseDateString = (dateString) => {
  if (!dateString || typeof dateString !== "string") return;
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const chunkArray = (arr, size) => {
  try {
    return arr.length > size
      ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)]
      : [arr];
  } catch (error) {
    return [arr];
  }
};

export const cancellablePromise = (promise) => {
  let rejectFn;
  const wrappedPromise = new Promise((resolve, reject) => {
    rejectFn = reject;

    Promise.resolve(promise).then(resolve).catch(reject);
  });
  wrappedPromise.cancel = () => {
    rejectFn({ canceled: true });
  };
  return wrappedPromise;
};

export async function executeAsyncFunctionsSequentially(asyncFunctionsArray) {
  if (!isArrayItems(asyncFunctionsArray) && asyncFunctionsArray.length === 0)
    return;
  try {
    for (const func of asyncFunctionsArray) {
      await func();
    }
  } catch (error) {
    console.error("An error occurred:", error);
  }
}

export const CheckArrayForItem = (array, item) => {
  return Array.isArray(array) && array.includes(item);
};

export function arraySort(array, key, sortOrder = "asc") {
  if (!Array.isArray(array) || array.length <= 1) return array;

  let keyExistsOnArray = true;
  array.forEach((object) => {
    if (!object.hasOwnProperty(key)) keyExistsOnArray = false;
  });
  if (keyExistsOnArray === false) {
    return array;
  }

  const sorted = array.sort((a, b) => {
    let labelA, labelB;
    switch (typeof key) {
      case "string":
        labelA = (a[key] || "").toUpperCase();
        labelB = (b[key] || "").toUpperCase();

        break;

      default:
        labelA = a[key] || "";
        labelB = b[key] || "";
        break;
    }
    if (labelA < labelB) {
      return sortOrder === "asc" ? -1 : 1;
    }
    if (labelA > labelB) {
      return sortOrder === "asc" ? 1 : -1;
    }

    return 0;
  });
  return sorted;
}

export const parseExtension = (string) => {
  try {
    if (!string) return new Error("invalid input");
    const extension = string.match(/\.([^.]+)$/);
    if (!Array.isArray(extension) || extension.length < 2)
      return new Error("error parsing extension");
    return extension[1];
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const formatBytes = (bytes, decimals = 2) => {
  try {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  } catch (error) {
    return "";
  }
};

export const removeFileExtension = (string) => {
  try {
    if (typeof string !== "string") return new Error("invalid input");

    return string.replace(/\.[^/.]+$/, "");
  } catch (error) {
    console.log(error);
    return string;
  }
};

export const sleep = async (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
